<template>
    <div>
        <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100 px-4 mt-4">
            <div class="row w-100 flex-column flex-lg-row">
                <!-- <cityAndProvince
                    @selectedCity      = "selectedCity"
                    @selectedProvince  = "selectedProvince"

                    :update-city-selected="updateCitySelected"
                    :citys             ="citys"
                    :province-items    ="provinceItems"
                    :city-selected     ="citySelected"
                    :province-selected ="provinceSelected"
                /> -->
                <searchForm @searchData="searchData" />
            </div>
        </div>
        <tableContent @modalShowEntryPay="modalShowEntryPay" :tableData="halls" />
    </div>
</template>

<script>
import tableContent from './tableContent'
import searchForm from './searchForm'
// import cityAndProvince from './cityAndProvince'

export default {
  components: {
    tableContent,
    searchForm
    // cityAndProvince
  },
  props: {
    halls: {
      type: Array,
      required: true
    },
    citys: { type: Array, default: () => [] },
    provinceItems: { type: Array, default: () => [] },
    citySelected: { type: Object, default: () => {} },
    provinceSelected: { type: Object, default: () => {} },
    updateCitySelected: { type: Number, default: 0 }
  },
  methods: {
    modalShowEntryPay (data) {
      this.$emit('modalShowEntryPay', data)
    },
    searchData (data) {
      this.$emit('searchData', data)
    },
    selectedCity (data) {
      this.$emit('selectedCity', data)
    },
    selectedProvince (data) {
      this.$emit('selectedProvince', data)
    }
  }
}
</script>
